import React from 'react';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';

import Action from './action/action';
import Modal from '../modal/modal';

import defaultStyles from './action-sheet.scss';

export { Action };

export interface Props {
    styles: typeof defaultStyles;
    onClose: () => void;
    open: boolean;
    children: (props: { close: React.ReactNode }) => React.ReactNode;
}

class ActionSheet extends React.PureComponent<Props> {
    close = () => {
        if (this.props.onClose) {
            this.props.onClose();
        }
    };

    render() {
        const { styles, open, onClose } = this.props;
        return (
            <Modal open={open} onClose={onClose} style={{ modal: styles.modal, overlay: styles.overlay }}>
                <ul className={styles.actions}>
                    {this.props.children({
                        close: (
                            <Action onClick={onClose}>
                                <FormattedMessage id='BUTTON_LABEL_CLOSE' />
                            </Action>
                        ),
                    })}
                </ul>
            </Modal>
        );
    }
}

export default Styled(defaultStyles)(ActionSheet);
